import React from 'react';
import { MockupCrop } from '../MockupCrop';
import { TeachingFlow } from './TeachingFlow';
import { systemFlow, volumes } from '../../data/content';
import { volumesBand } from '../../data/images';

/** Section 5 — the product itself: six core volumes, no bonuses. */
export function SystemSection() {
  return <section aria-labelledby="system-heading" className="bg-brand-paper px-5 py-16 lg:px-8 lg:py-24" data-id="element-194" data-mp="398ne9v5uu1dn">
      <div className="mx-auto max-w-6xl" data-id="element-195" data-mp="uofymveu3wz">
        <div className="mx-auto max-w-2xl text-center" data-id="element-196" data-mp="vq2polsgeuj">
          <p className="font-body text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-gold" data-id="element-197" data-mp="5ronz3btlgqq">
            Meet Your New Teaching System
          </p>
          <h2 id="system-heading" className="mt-4 font-display font-bold leading-[0.95] text-brand-charcoal" data-id="element-198" data-mp="3s8azs54a1rby">
            <span className="block text-[2.3rem] uppercase sm:text-[3.2rem]" data-id="element-199" data-mp="jsr83aj98gz0">Makeup Instructor</span>
            <span className="block text-[3.2rem] italic text-brand-gold sm:text-[4.4rem]" data-id="element-200" data-mp="ojptgoj3o594">Ready</span>
          </h2>
          <p className="mt-5 text-[16px] font-semibold leading-relaxed text-brand-charcoal/80 sm:text-[17px]" data-id="element-201" data-mp="2n0g1akmtfpbk">
            Everything You Need to Plan, Teach, Practice, Assess & Manage Makeup Education.
          </p>
        </div>

        <MockupCrop crop={volumesBand} alt="The six core volumes of Makeup Instructor Ready" className="mt-12 hidden md:block" data-id="element-202" data-mp="2vuuhcpf673vq" />

        <ol className="mt-12 grid grid-cols-2 gap-x-4 gap-y-6 md:hidden" data-id="element-203" data-mp="35qxroik6e8tr">
          {volumes.map(volume => <li key={volume.number} className="text-center" data-id="element-204" data-mp="30run0z83y4mb">
              <div className="flex aspect-[3/4] items-end justify-center" data-id="element-205" data-mp="3es5eo4h8rn8j">
                <MockupCrop crop={volume.crop} alt={`Volume ${volume.number} cover — ${volume.title}`} className="max-h-full w-full" data-id="element-206" data-mp="3eq2sxwn4gg9m" />
              </div>
              <p className="mt-3 font-body text-[11px] uppercase tracking-[0.18em] text-brand-charcoal/50" data-id="element-207" data-mp="1gd2gz3vosq70">
                Volume {volume.number}
              </p>
            </li>)}
        </ol>

        <p className="mx-auto mt-8 w-fit rounded-full bg-brand-plum px-5 py-2 font-body text-[12px] font-bold uppercase tracking-[0.16em] text-white" data-id="element-208" data-mp="3kg42xsivpbpx">
          6 Core Professional Volumes
        </p>

        <TeachingFlow steps={systemFlow} size="lg" className="mt-10" data-id="element-209" data-mp="3ufctscig6a82" />

        <p className="mx-auto mt-6 max-w-xl text-center text-[15px] leading-relaxed text-brand-charcoal/70 sm:text-[16px]" data-id="element-210" data-mp="2b0sdsa587i4">
          Each volume solves a different part of makeup education. Together, they create one connected
          teaching workflow you can return to class after class.
        </p>
      </div>
    </section>;
}